import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages the size guide drawer.
 *
 * @extends {DialogComponent}
 */
class SizeGuideDrawerComponent extends DialogComponent {
  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('size-guide-drawer-component')) {
  customElements.define('size-guide-drawer-component', SizeGuideDrawerComponent);
}

/**
 * A custom element that toggles the measurement unit (in/cm) shown in the size guide drawer.
 */
class SizeGuideUnitToggle extends HTMLElement {
  connectedCallback() {
    this.switchEl = this.querySelector('.size-guide-toggle__switch');
    this.root = this.closest('[data-size-guide-root]');
    this.unit = this.getAttribute('data-default-unit') === 'cm' ? 'cm' : 'in';

    this.switchEl?.addEventListener('click', () => this.toggle());
  }

  toggle() {
    this.unit = this.unit === 'in' ? 'cm' : 'in';
    this.apply();
  }

  apply() {
    this.root?.setAttribute('data-unit', this.unit);
    this.switchEl?.setAttribute('aria-checked', String(this.unit === 'cm'));
  }
}

if (!customElements.get('size-guide-unit-toggle')) {
  customElements.define('size-guide-unit-toggle', SizeGuideUnitToggle);
}
